import { boolean, defineAction, enumerated, object, string } from '~/prix'
import monitorProductYearlyCumulativeImportAction from './monitorProductYearlyCumulativeImport.action.json'

const monitorProductYearlyCumulativeImportDefinition = defineAction({
  ...monitorProductYearlyCumulativeImportAction,
  input: object({
    file: string().isOptional(),
    contentType: string().isOptional(),
  }),
  output: object({
    success: boolean(),
  }),
})

export default monitorProductYearlyCumulativeImportDefinition
